import React, { useEffect, useState } from 'react';
import UserSidebar from './UserSidebar';
import './UserDashboard.css';
import {
  FiBell,
  FiMenu,
  FiSearch,
  FiUser,
} from 'react-icons/fi';

export default function UserLayout({ children, title = 'Dashboard', subtitle = 'Welcome back' }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setCollapsed(false);
      }
      if (window.innerWidth >= 992) {
        setMobileSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="user-dashboard-shell">
      <UserSidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileSidebarOpen={mobileSidebarOpen}
        setMobileSidebarOpen={setMobileSidebarOpen}
      />

      {mobileSidebarOpen && (
        <div
          className="user-sidebar-backdrop"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      <div className={`user-main ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <header className="user-topbar">
          <div className="d-flex align-items-center gap-3">
            <button
              type="button"
              className="topbar-icon-btn d-lg-none"
              onClick={() => setMobileSidebarOpen(true)}
            >
              <FiMenu />
            </button>

            <div>
              <h4 className="user-page-title mb-0">{title}</h4>
              <div className="user-page-subtitle">{subtitle}</div>
            </div>
          </div>

          <div className="user-topbar-actions">
            <div className="topbar-search d-none d-md-flex">
              <FiSearch className="topbar-search-icon" />
              <input type="text" placeholder="Search dashboard..." />
            </div>

            <button type="button" className="topbar-icon-btn">
              <FiBell />
            </button>

            <div className="topbar-user">
              <div className="topbar-user-avatar">
                <FiUser />
              </div>
              <div className="topbar-user-text d-none d-sm-block">

                <span>User Workspace</span>
              </div>
            </div>
          </div>
        </header>

        <main className="user-content">{children}</main>
      </div>
    </div>
  );
}